import api from "./axios";

export const listFiles = () => api.get("/files");

export const uploadFile = (file, onProgress) => {
  const form = new FormData();
  form.append("file", file);
  return api.post("/files/upload", form, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress: (e) => onProgress && onProgress(Math.round((e.loaded * 100) / e.total)),
  });
};

export const uploadYouTube = (url, name) =>
  api.post("/files/upload-youtube", { url, name });

export const ingestUrl = (url) =>
  api.post('/files/ingest-url', { url }).then(r => r.data);

export const deleteFile = (fileId) => api.delete(`/files/${fileId}`);

export const reindexFile = (fileId) => api.post(`/files/${fileId}/reindex`);
